import ApplicationController from './application_controller';

// Connects to data-controller="line-clamp"
export default class extends ApplicationController {
  static targets = ['content', 'buttons', 'openButton', 'closeButton'];

  connect() {
    super.connect();

    this.showReadMore();
  }

  showReadMore() {
    if (this.contentTarget.offsetHeight < this.contentTarget.scrollHeight
      || this.contentTarget.offsetWidth < this.contentTarget.scrollWidth) {
      this.buttonsTarget.classList.remove('d-none');
    } else {
      this.buttonsTarget.classList.add('d-none');
    }
  }

  readMore() {
    this.contentTarget.classList.remove('line-clamp');
    this.openButtonTarget.classList.add('d-none');
    this.closeButtonTarget.classList.remove('d-none');
  }

  readLess() {
    this.contentTarget.classList.add('line-clamp');
    this.openButtonTarget.classList.remove('d-none');
    this.closeButtonTarget.classList.add('d-none');
  }
}
